<template>
  <div :id="id" :option="option" style="width: 34px; height: 26px;"></div>
</template>
 
<script>
import echarts from 'echarts'
 
export default {
  props: ['id','value'],
  data() {
    return {
      // 评测得分进度条
      option:{
        title: {
            show: false
        },
        grid: [{
            show: false,
            backgroundColor: 'rgba(0,0,0,0)',
            borderWidth: 0,
            y: "bottom"
        }],
        series: [{
            type: "gauge",
            startAngle: 180,
            endAngle: 0,
            min: 0,
            max: 10,
            radius: "100%",
            //splitNumber: 8,
            center: ["50%", "65%"],
            axisLine: {
                show: true,
                lineStyle: {
                    width: 6,
                    // shadowBlur: 10,
                    color: [
                        [0, 'transparent'],
                        [0.2, '#ee2e2e'],
                        [0.21, 'transparent'],
                        [0.4, '#eb933a'],
                        [0.41, 'transparent'],
                        [0.6, '#f5df4b'],
                        [0.61, 'transparent'],
                        [0.8, '#cee450'],
                        [0.81, 'transparent'],
                        [1, '#a0cb6c']
                    ]
                }
            },
            axisTick: {
                show: false
            },
            axisLabel: {
                show: false
            },
            splitLine: {
                show: false
            },
            pointer: {
                width: "6%",
                length: '80%',
                color: "black"
            },
            itemStyle: {
                normal: {
                    color: "rgba(0, 0, 0, 0.8)",
                    shadowBlur: 20
                }
            },
            title: {
                show: false
            },
            //仪表盘详情，用于显示数据。
            detail: {
              show: false,
              offsetCenter: [0, '70%'],
              color: '#00C1D1',
              formatter: function(params) {
                  return params
              },
              textStyle: {
                fontSize: 40
              }
            },
            data: [{
                value: this.value
            }]
        }]
      }
    }
  },
  mounted() {
    const chart = echarts.init(document.getElementById(this.id));
    chart.setOption(this.option);
  },
  watch: {
    option: function(newOption) {
      const chart = echarts.getInstanceByDom(document.getElementById(this.id));
      if (chart) {
        chart.setOption(newOption);
      }
    }
  }
}
</script>